import React, { Component } from "react";
import Lottie from "react-lottie";
import LoadingAnimation from "./images/LoadingAnimation.json";

export default class Loader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false
    };
  }

  componentDidMount() {
    setTimeout(() => this.setState({ redirect: true }), 1000);
  }

  render() {
    return (
      <div className='home-loader'>
        <Lottie options={{ animationData: LoadingAnimation }} height={100} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Loader.js